// URL detection + HTML rendering helper.
//
// Matches http(s):// URLs and bare www.* URLs in plain text. Trailing
// sentence punctuation like `.`, `,`, `;`, `:` etc. is stripped off the URL
// so a sentence "Xem tại https://abc.vn/page." doesn't link the dot.

const URL_REGEX = /\b((?:https?:\/\/|www\.)[^\s<>"'`]+)/gi;

const TRAILING_PUNCT = /[.,;:!?)\]}'"”’»]+$/;

function escapeHtml(text) {
  return String(text == null ? '' : text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

function trimTrailingPunct(url) {
  return url.replace(TRAILING_PUNCT, '');
}

// Returns true if the input contains any URL.
export function hasLink(text) {
  if (text == null) return false;
  return new RegExp(URL_REGEX.source, 'gi').test(String(text));
}

// Returns HTML-safe string with URLs wrapped in <a class="auto-link">...</a>.
// Non-URL text is HTML-escaped. \n becomes <br> when `newlineToBr` is true.
export function linkifyText(text, { newlineToBr = true } = {}) {
  if (text == null) return '';
  const src = String(text);
  const re = new RegExp(URL_REGEX.source, 'gi');
  let out = '';
  let cursor = 0;
  let m;
  while ((m = re.exec(src)) !== null) {
    const raw = m[1];
    const url = trimTrailingPunct(raw);
    const start = m.index;
    const end = start + url.length;
    out += escapeHtml(src.slice(cursor, start));
    const href = url.startsWith('www.') ? 'https://' + url : url;
    out += `<a href="${escapeHtml(href)}" target="_blank" rel="noopener noreferrer" class="auto-link" onclick="event.stopPropagation()">${escapeHtml(url)}</a>`;
    cursor = end;
    // Make sure the regex doesn't keep matching from inside the trimmed URL
    re.lastIndex = end;
  }
  out += escapeHtml(src.slice(cursor));
  if (newlineToBr) out = out.replace(/\n/g, '<br>');
  return out;
}
